/**
 * @module Terms
 * @description
 */
import Head from "next/head";

// Template
import Template from "@/templates/Default";

// const location = 'TERMS';

/**
 * @function Page
 * @description
 */
const Page = () => (
  <>
    <Head>
      <title>Terms | FrontierInternet</title>
    </Head>

    <Template
      title="Terms"
      primary={
        <div className="l-container text-center terms">
          <p className="h2">Terms & Conditions</p>
          <p>
            This page states the Terms and Conditions under which you the Web
            Site visitor(“You”) may use Frontierinternet.com (the “Site”), which
            are operated by frontierinternet.com.
          </p>
          <p>
            Please read this page carefully. By using this Site, You agree to be
            bound by all of the Terms and Conditions set forth below. If You do
            not accept these Terms and Conditions, please do not use this Site.
            These Terms and Conditions supersede any other agreement that you
            may have with frontierinternet.com regarding this subject matter.
            frontierinternet.com may, in its sole discretion, revise these Terms
            and Conditions at any time; therefore, You should visit this page
            periodically to review the Terms and Conditions.
          </p>

          <p className="h5">Use of Site Material</p>
          <p>
            The contents of this Site, such as text, graphics, images and other
            content (the “Site Material”) are protected by copyright under both
            United States and foreign laws. These Terms and Conditions do not
            grant You any license whatsoever to the Site Material.
            Frontierinternet.com authorizes You to view and download a single
            copy of the Site Material for your non-commercial personal use.
            Unauthorized use of the Site Material violates copyright, trademark,
            and other laws. You agree to retain all copyright and other
            proprietary notices contained in the original Site Material on any
            copy of such material. Except as expressly provided herein, You may
            not sell or modify our Site Material or reproduce, display,
            distribute, or otherwise use the Site Material in any way for any
            public or commercial purpose. Use of the Site Material on any other
            web site or in a networked environment is prohibited.
            Frontierinternet.com retains all intellectual property rights in the
            Site Material.
          </p>

          <p className="h5">Trademarks</p>
          <p>
            The names, marks and logos appearing on the Site are, unless
            otherwise noted, trademarks owned by or licensed to
            Frontierinternet.com. Your use of these marks, except as provided in
            these Terms and Conditions, is prohibited. From time to time,
            Frontierinternet.com makes fair use in this Site of trademarks owned
            and used by third parties. Frontierinternet.com makes no claim to
            ownership of those marks.
          </p>

          <p className="h5">User Submissions</p>
          <p>
            Frontierinternet.com welcomes Your comments on our Site. However,
            You acknowledge that if You send us creative suggestions, ideas,
            recipes, notes, drawings, concepts, inventions or other information,
            (collectively, the “Information”), the Information shall be deemed,
            and shall remain Frontierinternet.com property. By submission of any
            Information to us, You assign to us and we shall own exclusively all
            rights to such Information of every kind and nature throughout the
            universe now known or hereafter existing. Frontierinternet.com shall
            be entitled to unrestricted use of the Information for any purpose
            whatsoever, commercial or otherwise, without compensation to You or
            the provider of the information.
          </p>

          <p>
            As a user of this Web site, You are responsible for Your own
            communications. Therefore, do not do any of the following things:
          </p>
          <ul className="text-left">
            <li>
              transmit to us material that is copyrighted, unless You are the
              copyright owner or have the permission of the copyright owner
            </li>
            <li>
              send material that reveals trade secrets, unless You own them or
              have the express permission of the owner to disclose those
              materials
            </li>
            <li>
              send material that infringes on any other intellectual property
              rights of others or on the privacy or publicity rights of others
            </li>
            <li>
              send material that is obscene, defamatory, threatening, harassing,
              abusive, hateful, or embarrassing to another user or any other
              person or entity
            </li>
            <li>
              intentionally or unintentionally violate or encourage conduct that
              would violate any local, state, or federal law
            </li>
            <li>send advertisements or solicitations of business</li>
            <li>send chain letters or pyramid schemes or</li>
            <li>impersonate another person</li>
          </ul>

          <p>
            Frontierinternet.com reserves the right to expel You and to prevent
            You further access to this Site for violating these Terms and
            Conditions terms or the law. The violation of any of these Terms and
            Conditions shall result in the immediate revocation of your right to
            access or use the Site or Site Material and obligates You to
            immediately destroy any copies of the Site Material in your
            possession.
          </p>
          <p className="h5">Limitation of Liability</p>
          <p>
            NEITHER Frontierinternet.com NOR Frontier WARRANT THAT THE WEB SITE
            WILL OPERATE ERROR-FREE OR THAT THE SITE AND ITS SERVER ARE FREE OF
            COMPUTER VIRUSES OR OTHER HARMFUL MATERIAL. IF YOUR USE OF THE SITE
            OR THE SITE MATERIAL RESULTS IN ANY COSTS OR EXPENSES, INCLUDING,
            WITHOUT LIMITATION, THE NEED FOR SERVICING OR REPLACING EQUIPMENT OR
            DATA, NEITHER Frontierinternet.com NOR Frontier SHALL BE RESPONSIBLE
            FOR THOSE COSTS OR EXPENSES.
          </p>
          <p>
            THIS WEB SITE AND ITS MATERIAL ARE PROVIDED ON AN “AS IS” AND “AT
            YOUR OWN RISK” BASIS WITHOUT ANY WARRANTIES OF ANY KIND.
            Frontierinternet.com and Frontier, TO THE FULLEST EXTENT PERMITTED
            BY LAW, DISCLAIMS ALL WARRANTIES, INCLUDING THE WARRANTY OF
            MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES RIGHTS, AND THE
            WARRANTY OF FITNESS FOR PARTICULAR PURPOSE. ALTHOUGH
            Frontierinternet.com STRIVES TO PROVIDE THOROUGH AND ACCURATE
            MATERIALS ON ITS SITE, WE MAKE NO WARRANTIES ABOUT THE ACCURACY,
            RELIABILITY, COMPLETENESS, OR TIMELINESS OF THE MATERIAL, SERVICES,
            SOFTWARE, TEXT, GRAPHICS, AND LINKS.
          </p>

          <p className="h5">Disclaimer of Consequential Damages</p>
          <p>
            IN NO EVENT SHALL Frontierinternet.com, Frontier, THEIR RESPECITVE
            AFFILIATES, OR ANY THIRD PARTIES MENTIONED ON THE SITE BE LIABLE FOR
            ANY DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, INCIDENTAL,
            INDIRECT, CONSEQUENTIAL OR PUNITIVE DAMAGES, LOST PROFITS, OR
            DAMAGES RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION) RESULTING
            FROM THE USE OR INABILITY TO USE MATERIAL ON THIS SITE OR SITES
            LINKED TO THIS SITE, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR
            ANY OTHER LEGAL THEORY, AND WHETHER OR NOT Frontierinternet.com OR
            Frontier IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>

          <p className="h5">Links</p>
          <p>
            This Site contains links to web sites owned by third parties. These
            links are provided solely as a convenience to You and are not an
            endorsement by Frontierinternet.com of the contents on those other
            sites. Frontierinternet.com is not responsible for the content of
            any linked sites and makes no representations regarding the content
            or accuracy of materials on such sites. If You decide to visit any
            third-party sites using links from this Site, You do so at your own
            risk. Consult the Uniform Resources Locator (“URL”) address
            identified in your browser to determine whether you have linked to a
            third-party Site.
          </p>

          <p className="h5">Indemnity</p>
          <p>
            By using this Site, You agree to defend, indemnify, and hold
            harmless Frontierinternet.com, its officers, directors, employees
            and agents (collectively, the “Parties”), from and against any and
            all losses, claims, damages, costs and expenses (including
            reasonable legal and accounting fees) that the parties may become
            obligated to pay arising or resulting from your use of the Site
            Material or your breach of these Terms and Conditions. The parties
            reserve the right to assume or participate, at your expense, in the
            investigation, settlement and defense of any such action or claim.
          </p>

          <p className="h5">Privacy</p>
          <p>
            Please see Frontierinternet.com’s{" "}
            <a href="https://www.frontierinternet.com/privacy.html">
              Privacy Policy
            </a>
            .
          </p>

          <p className="h5">Miscellaneous</p>
          <p>
            This Web Site originates from Fort Mill, South Carolina.
            Frontierinternet.com does not claim that the Site Material is
            appropriate or may be used outside of the United States. Access to
            the Site Material may not be legal by certain persons or in certain
            countries. If You access the Site from outside of the United States,
            You do so at your own risk and are responsible for compliance with
            the laws of your jurisdiction.
          </p>
          <p>
            These Terms and Conditions are governed by the substantive laws of
            the State of North Carolina, without respect to its conflict of laws
            principles. You agree to submit to the jurisdiction of the courts
            situated in Lancaster County, South Carolina with respect to any
            dispute, disagreement, or cause of action related to or involving
            this Site. If any provision is found to be invalid by any court
            having competent jurisdiction, the invalidity of such provision
            shall not affect the validity of the remaining provisions of these
            Terms and Conditions, which shall remain in full force and effect.
            No waiver of any of these Terms and Conditions shall be deemed a
            further or continuing waiver of such term or any other term. Except
            as expressly provided elsewhere in our Site, these Terms and
            Conditions constitute the entire agreement between You and
            Frontierinternet.com with respect to your use of this Site.
          </p>
        </div>
      }
    />
  </>
);

export default Page;
